<template>
  <div>
    彩票经理/代表申请
    <el-form label-width="250px" >
      <el-form-item label="用户名/昵称:">
        <el-input placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="手机:">
        <el-input placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="真实姓名:">
        <el-input placeholder=""></el-input>
        <span>一旦实名认证将不能修改,并且要和提现银行卡/微信/支付宝的姓名一致</span>
      </el-form-item>
      <el-form-item label="身份证号:">
        <el-input placeholder=""></el-input>
        <span>一旦实名认证将不能修改</span>
      </el-form-item>
      <el-form-item label="彩票经理/彩票代表">
        <el-select v-model="jl_db.value" placeholder="">
          <el-option 
            v-for="(item,index) in jl_db.arr" :key="index"
            :label="item.label" :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入驻彩种:">
        <el-select v-model="lotteryType" placeholder="">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        彩票代表入驻个人说明
      </el-form-item>
      <el-form-item label="身份证上传">
        <el-upload action="">
          <el-button type=""></el-button>
        </el-upload>
        <el-upload action="">
          <el-button type=""></el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="头像上传">
        <el-upload action="">
          <el-button type=""></el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="是否有60人以上彩票QQ群,微信群">
        <el-input placeholder="如果没有填无,如果有,说明QQ号,微信号"></el-input>
      </el-form-item>
      <el-form-item label="是否是投注站站长">
        <el-input placeholder="如果没有填无,如果有,说明投注站信息"></el-input>
      </el-form-item>
      <el-form-item label="是否最近10期双色球围4蓝10期中7期">
        <el-radio label="是"></el-radio>
        <el-radio label="否"></el-radio>
        <span>上传截图</span>
        <span>如果双色球围4码10中7，只能申请双色球彩票代表</span>
      </el-form-item>
      <el-form-item label="是否最近10期大乐透后区10期中9期">
        <el-radio label="是"></el-radio>
        <el-radio label="否"></el-radio>
        <span>上传截图</span>
        <span>如果大乐透围3后10中9，只能申请大乐透彩票代表</span>
      </el-form-item>
      <el-form-item label="QQ号">
        <el-input placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="微信号">
        <el-input placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="生日">
        <el-input placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="性别">
        <el-radio label="男"></el-radio>
        <el-radio label="女"></el-radio>
        <el-radio label="保密"></el-radio>
      </el-form-item>
      <el-form-item label="分享一个我经历的彩票小故事">
        <el-input type="textarea" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="最喜欢的彩票座右铭">
		<div style="display:flex">
        <el-input placeholder="用一句话概括" v-model="form.motto"></el-input>
<el-button type="primary" style="margin-left: 20px;" @click="$refs.popupMotto.init()">选择座右铭</el-button>
		</div>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary">确认</el-button>
      </el-form-item>
    </el-form>


	<motto ref="popupMotto" @confirm="e=>this.form.motto = e"></motto>
  </div>
</template>

<script>
import motto from '@/components/motto/index.vue'
export default {
	components:{ motto },
    data(){
        return{
            lotteryType:'双色球',
            options:[
                {label:'双色球',value:1},
                {label:'大乐透',value:2},
            ],
            jl_db:{
              value:'彩票经理',
              arr:[
                {label:'彩票经理',value:1},
                {label:'彩票代表',value:2}
              ]
            },
			form:{
				motto:'',
			}

        }
    }
}
</script>

<style lang="scss" scoped>

</style>